module.exports = __webpack_public_path__ + "static/media/peronteto-acel-szerkezet.486a6808.jpg";